export default __webpack_public_path__ + "static/media/dazn.link-red.4e6f98fb.png";